import { DesktopWindows, GitHub } from "@mui/icons-material";
import React from 'react';
import { Carousel } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import "../../css/PortfolioDetails.css";
import useProvider from '../../Hooks/useProvider';
const PortfolioDetails = () => {
    const { id } = useParams()
    const data = useProvider();
    const { portfolioData } = data.data;
    const clickedItem = portfolioData.find(item => item.id === id);
    const { name, images, description, backend, frontend, features, tools, link } = clickedItem;
    return (
        <div className="portfolioDetails container px-3">
            <div className="portfolioDetails__slider">
                <h2 className="text-center pb-2">Few More images </h2>
                <Carousel indicators={false} variant="dark" fade className="slider">
                    {
                        images.map(img => {
                            return (
                                <Carousel.Item >
                                    <img
                                        className="d-block w-100"
                                        src={`${img}.png`}
                                        alt="website-img"
                                    />
                                </Carousel.Item>

                            )
                        })
                    }

                </Carousel>
            </div>
            <div className="portfolioDetails__details">
                <div className="left">
                    <h2>{name} </h2>
                    <p>{description} </p>
                    <div>
                    
                        <a  target="_blank" rel="noreferrer"   className="me-3" href={frontend} title="Frontend Code"> <GitHub /> </a>
                        {
                            backend && <a target="_blank" rel="noreferrer"   className="me-3" href={backend} title="Backend Code"> <GitHub /> </a>
                        }
                        <a  target="_blank" rel="noreferrer"  href={link} title="Live Site"> <DesktopWindows /> </a>
                    </div>
                </div>
                <div className="right">
                <div>
                    <h4>Website Features  </h4>
                    <ol>
                        {
                            features.map((item, ind )=> <li key={ind}>{item} </li>)
                        }
                    </ol>
                </div>
                <div>
                    <h4>Website Tools </h4>
                    <ol>
                        {
                            tools.map((item, ind )=> <li key={ind}>{item} </li>)
                        }
                    </ol>
                </div>
                
                </div>
            </div>
        </div>
    )
}

export default PortfolioDetails;